export const DELETE_FILE_REFERENCE_REQUEST = 'DELETE_FILE_REFERENCE_REQUEST';

export const deleteFileReferenceRequest = ( id: string ) => ({
    type: DELETE_FILE_REFERENCE_REQUEST,
    payload: { id }
});
